module.exports = __webpack_public_path__ + "img/BaliBody3.0ea4eacd.jpg";